var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.3387 1.27459C7.3387 0.81917 7.70851 0.449365 8.16393 0.449365C8.61936 0.449365 8.98916 0.819169 8.98916 1.27459L8.98734 7.44468L15.1574 7.4465C15.6128 7.4465 15.9827 7.8163 15.9827 8.27173C15.9827 8.72715 15.6128 9.09696 15.1574 9.09696L8.98734 9.09513L8.98552 15.2652C8.98552 15.7206 8.61571 16.0904 8.16029 16.0904C7.70486 16.0904 7.33506 15.7206 7.33506 15.2652L7.33688 9.09513L1.1668 9.09331C0.711372 9.09331 0.34339 8.72533 0.34339 8.26991C0.34339 7.81448 0.713194 7.44468 1.16862 7.44468L7.33688 7.44468L7.3387 1.27459Z",
    fill: "#3F69FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIcon);
export default __webpack_public_path__ + "static/media/plus-icon.9b1b9e51f2403a963c613999ebb03826.svg";
export { ForwardRef as ReactComponent };